enum EImportSpreadsheetStatus {
  Concluded = 'CONCLUIDO',
  Failure = 'FALHA',
  Processing = 'PROCESSANDO',
}

export default EImportSpreadsheetStatus;
